import $ from 'jquery';
import config from '../../../config';

// Save Leave
export function save_leave( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave_type/',
			data: {
                method: 'SAVE_LEAVETYPE',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_LEAVETYPE",
				leave_type: response
			})
		})

	}
}

// Get Leave
export function get_leave(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave_type/',
			data: {
                method: 'GET_LEAVETYPE'
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVETYPE",
				leave_type: response
			})
		})

	}
}

// Delete Leave
export function delete_leave( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave_type/',
			data: {
				method: 'DELETE_LEAVETYPE',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_LEAVETYPE",
				leave_type: response
			})
		})

	}
}

// Get By ID Leave
export function get_leave_by_id( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave_type/',
			data: {
				method: 'GET_BY_ID_LEAVETYPE',
				id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_BY_ID_LEAVETYPE",
				leave_type: response
			})
		})

	}
}


// Edit Leave
export function edit_leave( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave_type/',
			data: {
				method: 'EDIT_LEAVETYPE',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "EDIT_LEAVETYPE",
				leave_type: response
			})
		})

	}

}


// WEBPACK FOOTER //
// ./src/pages/leave_type/actions/leave.action.js